<template>
  <v-container fluid>
    <PageHeading
      text="Места"
      mode="grid"
      :grid-data-loading="gridDataLoading"
      :results-count="resultsCount"
    >
      <template v-slot:[`toolbar.prepend`]>
        <v-btn
          link
          small
          outlined
          color="primary"
          class="mx-2 mt-2"
          :to="{
            name: 'page-place-new'
          }"
        >
          <v-icon
            class="mr-2"
            small
          >
            mdi-plus
          </v-icon>
          Создать место
        </v-btn>
      </template>
    </PageHeading>
    <v-row>
      <v-col>
        <GridPlaces ref="grid"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GridPlaces from './grid'
import PageHeading from '@/components/page-heading'
import gridPageInterface from '@/interfaces/grid-page-interface-mixin'

export default {
  components: {
    PageHeading,
    GridPlaces
  },
  metaInfo () {
    return {
      title: 'Места'
    }
  },
  mixins: [gridPageInterface]
}
</script>
